import config from '../../template-setting.json';

export default config;
